import React, {useEffect, useState} from 'react';
import API from "libs/api";
import {Button, Modal} from 'semantic-ui-react';
import PROCESSING from "components/cmp_processing/cmp_processing";

import './mdl_latlon.css';

export default function MDL_LATLON({onClose, onOpen, onRefresh, var_location, set_location, var_providerID}) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [var_data, set_data] = useState([]);
    const [var_processing, set_processing] = useState('inactive');
    const [var_can_process, set_can_process] = useState(true);



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (onOpen) {
            get_geoapify();
        }
    }, [onOpen])



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_geoapify() {

        set_data([]);
        set_can_process(false);
        set_processing('processing');

        try {
            let var_validate_address = var_location.address + ', ' + var_location.city + ', ' + var_location.state + ', ' + ', ' + var_location.country
            let var_geoapify = await fetch('https://api.geoapify.com/v1/geocode/search?text=' + encodeURIComponent(var_validate_address) + '&limit=4&format=json&apiKey=' + process.env.REACT_APP_GEOAPIFY_KEY);
            const var_geoapify_json = await var_geoapify.json();

            let locations = [];
            for (const element of var_geoapify_json.results) {

                if (element.city === 'Old Toronto') {
                    element.city = 'Toronto'
                }

                let locationCheck = await API_get_location_check(element.housenumber + ' ' + element.street)

                let location = {}
                location.housenumber = element.housenumber;
                location.street = element.street;
                location.city = element.city;
                location.state_code = element.state_code
                location.country = element.country;
                location.lat = element.lat;
                location.lon = element.lon;
                location.geoapify_confidence = element.rank.confidence;
                location.matches = locationCheck.matches;
                location.pages = locationCheck.pages;
                locations.push(location)
            }

            //  set data
            set_data(locations);


            set_processing('inactive');
            set_can_process(true);
        } catch (e) {
            set_processing('error');
        }
    }


    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_location_check(var_address) {
        return API.get('admin-providers', '/get-location-check/' + var_providerID + '/' + var_address);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_update() {

    }

    function onClick_cancel() {
        onClose();
    }

    function onClick_geoapify(item){
        let location = {...var_location};
        if (item.housenumber) {
            location.address = item.housenumber + ' ' + item.street;
        } else {
            location.address = item.street;
        }
        location.city = item.city;
        location.state = item.state_code;
        location.country = item.country;
        location.lat = item.lat.toFixed(5)
        location.lon = item.lon.toFixed(5)
        location.geoapify_confidence = (item.geoapify_confidence * 100).toFixed(0)
        location.reviewed = 'YES';
        set_location(location);
        onClose();
    }



    // RENDER APP ======================================================================================================

    return (
        <Modal
            dimmer={'inverted'}
            onClose={onClose}
            open={onOpen}
            closeOnEscape={true}
            closeOnDimmerClick={true}
            id='mdl_latlon'>

            <div className="modal__header">
                <div className='modal__header__text'>
                    <div className='text--md bold'>Add Lat/Lon</div>
                    <div className='text--sm color--gray--600'>Verify Lat/Lon coordinates for the address</div>
                </div>
            </div>

            <div className='modal__content'>
                <div className='verify_address__wrapper'>
                    <div className='field__label medium'>Current address</div>
                    <div className='text--base'>{var_location.address}</div>
                    <div className='text--base'>{var_location.city}, {var_location.state}, {var_location.country}</div>
                </div>

                <div className='geoapify__wrapper'>
                    {var_data.length > 0 &&
                        <div className='geoapify__items'>
                            <div className='field__label medium'>Address options</div>
                            {var_data.map((item, index) =>
                                <div className='geoapify__item' key={index} onClick={()=>onClick_geoapify(item)}>
                                    <div className='text--base'>{item.housenumber} {item.street}</div>
                                    <div className='text--base'>{item.city}, {item.state_code}, {item.country}</div>
                                    {item.street &&
                                        <div className={'text--sm' + (item.matches > 0 ? ' green' : ' red')}>Matches/pages: {item.matches}/{item.pages}</div>
                                    }
                                    <div className='geoapify__latlon'>
                                        <div className='geoapify__latlon__wrapper'>
                                            <div className='text--sm bold'>Lat: </div>
                                            <div className='text--sm'>{item.lat.toFixed(5) || '-'}</div>
                                        </div>
                                        <div className='geoapify__latlon__wrapper'>
                                            <div className='text--sm bold'>Lon: </div>
                                            <div className='text--sm'>{item.lon.toFixed(5) || '-'}</div>
                                        </div>
                                        <div className='geoapify__latlon__wrapper'>
                                            <div className='text--sm bold'>Confidence: </div>
                                            <div className='text--sm'>{(item.geoapify_confidence * 100).toFixed(0)}%</div>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    }
                </div>
            </div>

            <PROCESSING state={var_processing}/>
            <div className='modal__footer'>
                <Button className='secondary' onClick={onClick_cancel}>Cancel</Button>
            </div>
        </Modal>
    );
}
